import type { AxiosError } from "axios"
import moment from "moment"
import { useMutation, useQuery } from "react-query"
import apiClient from "../Utils/apiClient"
import { returnArray } from "../Utils/reactQueryUtils"
import type { ExportOption, ExportRequest } from "../dtos"
import type { ExportGroup, Product } from "../enums"

const baseUrl = import.meta.env.VITE_BASE_URL
const apiUrl = import.meta.env.VITE_EXPORT_API
const url = `${baseUrl}/${apiUrl}`

export const useGetExportOptions = (product?: Product, group?: ExportGroup) => {
  return useQuery({
    queryKey: ['GetExportOptions', product, group],
    queryFn: () => apiClient.get<ExportOption[]>(`${url}/GetExportOptions`, { params: { product, group } }).then(returnArray)
  })
}

export const useGetExportUrl = (request: ExportRequest) => {
  const params = new URLSearchParams()
  params.append('Product', request?.product?.toString() || '0')
  params.append('ExportType', request.exportType.toString())
  params.append('DateType', request.dateType.toString())
  params.append('fileformat', request.fileFormat.toString())
  if (request.email)
    params.append('Email', request.email)
  params.append('DateFrom', moment(request.dateFrom).format('YYYY-MM-DD'))
  params.append('DateTo', moment(request.dateTo).format('YYYY-MM-DD'))

  return `${url}/GetExport?${params.toString()}`
}

export const useSendExportEmail = (request: ExportRequest) => {
  const url = useGetExportUrl(request)

  return useMutation<string, AxiosError>({
    mutationFn: () => apiClient.get(url).then(res => res.data)
  })
}